module.exports = __webpack_public_path__ + "static/4-5af678cd60eba6f3701ba45731cbedf9.jpg";